import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import { useTheme } from './ThemeContext';

const UserProfile = () => {
  const { isDark } = useTheme();
  const [profile, setProfile] = useState({
    name: 'John Doe',
    email: 'john@example.com',
    password: '********'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile({ ...profile, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Submit profile updates (e.g., API call)
    alert('Profile updated!');
  };

  return (
    <div className={`flex min-h-screen ${isDark ? 'dark' : 'light'}`}>
      <Sidebar role="user" />
      <div className="flex-1 p-6">
        <h1 className="text-2xl font-bold mb-4">User Profile</h1>
        <div className={`${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white'} shadow-lg rounded-lg p-6`}>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700">Name</label>
              <input
                type="text"
                name="name"
                value={profile.name}
                onChange={handleChange}
                className="w-full p-2 border rounded"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Email</label>
              <input
                type="email"
                name="email"
                value={profile.email}
                onChange={handleChange}
                className="w-full p-2 border rounded"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Password</label>
              <input
                type="password"
                name="password"
                value={profile.password}
                onChange={handleChange}
                className="w-full p-2 border rounded"
              />
            </div>
            <button type="submit" className="bg-indigo-500 text-white py-2 px-4 rounded">
              Update Profile
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
